// The contest page's backing-share strings. They live here rather than in
// copy.ts, which is past the file budget (EPIC-022 Locked architecture).
export const backingCopy = {
  // The pool header's fee line when the market pays a backing share: every
  // slice that comes off the pool, named (invariant 17).
  fee: (rake: string, producer: string, backing: string) =>
    `${rake} platform fee, ${producer} to the winning producer, and ${backing} of fans' picks to the producers they back come off the pool before it is split.`,
  earned: (amount: string, backers: number) =>
    `${amount} earned from ${backers} ${backers === 1 ? "backer" : "backers"} so far`,
  earnedSub: "Your backing share. It's paid when the contest settles, win or lose.",
};
